import type { SVGProps } from 'react';
const DawnFlagKE = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-KE_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-KE_svg__a)">
      <path fill="#262626" fillRule="evenodd" d="M0 4.267h22V0H0z" clipRule="evenodd" />
      <path fill="#018301" fillRule="evenodd" d="M0 16h22v-4.267H0z" clipRule="evenodd" />
      <path fill="#fff" fillRule="evenodd" d="M0 11.733h22V4.267H0z" clipRule="evenodd" />
      <path
        fill="#DC0808"
        fillRule="evenodd"
        d="M0 10.667h22V5.333H0z"
        clipRule="evenodd"
      />
      <path
        fill="#BC0000"
        fillRule="evenodd"
        d="M11 13.333c1.047 0 2.619-2.093 2.619-5.333s-1.572-5.333-2.62-5.333C9.953 2.667 8.382 4.76 8.382 8S9.952 13.333 11 13.333"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-KE_svg__b"
        width={6}
        height={12}
        x={8}
        y={2}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M11 13.333c1.047 0 2.619-2.093 2.619-5.333s-1.572-5.333-2.62-5.333C9.953 2.667 8.382 4.76 8.382 8S9.952 13.333 11 13.333"
          clipRule="evenodd"
        />
      </mask>
      <g mask="url(#dawn-flag-KE_svg__b)">
        <path
          fill="#262626"
          fillRule="evenodd"
          d="M6.81 13.867c1.446 0 2.619-2.627 2.619-5.867s-1.173-5.867-2.62-5.867C5.363 2.133 4.19 4.76 4.19 8s1.173 5.867 2.62 5.867M15.19 13.867c1.447 0 2.62-2.627 2.62-5.867s-1.173-5.867-2.62-5.867c-1.446 0-2.619 2.627-2.619 5.867s1.173 5.867 2.62 5.867"
          clipRule="evenodd"
        />
        <g filter="url(#dawn-flag-KE_svg__c)">
          <path
            fill="url(#dawn-flag-KE_svg__d)"
            fillRule="evenodd"
            d="M11 6.4c.29 0 .524-.955.524-2.133 0-1.179-.234-2.134-.524-2.134-.289 0-.523.955-.523 2.134S10.71 6.4 11 6.4m0 3.2c.29 0 .524-.716.524-1.6S11.29 6.4 11 6.4c-.289 0-.523.716-.523 1.6s.234 1.6.523 1.6m0 0c-.289 0-.523.955-.523 2.133s.234 2.134.523 2.134.524-.956.524-2.134S11.29 9.6 11 9.6"
            clipRule="evenodd"
          />
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-KE_svg__d"
        x1={10.477}
        x2={10.477}
        y1={2.133}
        y2={13.867}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#F0F0F0" />
      </linearGradient>
      <filter
        id="dawn-flag-KE_svg__c"
        width={1.048}
        height={12.733}
        x={10.477}
        y={2.133}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_996" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_996" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagKE;
